export default __webpack_public_path__ + "static/media/hero-bg-d.216ba0bb.jpg";